import { render, staticRenderFns } from "./MyPageRBCard.vue?vue&type=template&id=5ee38818"
import script from "./MyPageRBCard.vue?vue&type=script&lang=js"
export * from "./MyPageRBCard.vue?vue&type=script&lang=js"
import style0 from "./MyPageRBCard.vue?vue&type=style&index=0&id=5ee38818&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VIcon})
